export default __webpack_public_path__ + "static/media/secondSection.6faf294f.jpg";